import React, { useState } from 'react'
import { Box, Checkbox, Button, Grid } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider'
import DownloadSummary from './DownloadSummary'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '@configurator-messages'
import { Formik, Field, Form } from 'formik'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import * as yup from 'yup'
import ValidationErrors from '../../../validations/ValidationErrors'
import { configContext } from '../../../utils/StandardReducer'
import {
  TubeProperties,
  ActiveLinkType,
  ErrorMessage,
  TubeProduct,
} from '../enum'
import AddToCartItems from '@src/routes/Configurators/components/AddToCart/AddToCartItems'
import { priceFormatter } from '@src/routes/Configurators/utils/PriceFormatter'
import {
  useSessionFieldsMutation,
  useConfAddToMiniCartMutation,
  useTubePriceCallMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import { EMPTY_SESSION } from '../EmptySession'
import { standardTubeRoute, loginRoute, useRouter } from '@src/routes'
import {
  SnackbarType,
  useGlobalSnackbar,
} from '@src/components/GlobalSnackbar/globalSnackBarContext'
import {
  convertToASCII,
  getConfiguratorGAdata,
  validateSurrogateCharacters,
} from '@src/routes/Configurators/utils/util'
import CircleLoader from '@src/components/CircleLoader'
import {
  handleGAAddToCartForConfigurator,
  handleGAAddToCartErrorsForConfigurator,
} from '@utils/analytics/configuratorAnalytics'
import {
  ProductNames,
  ConfiguratorValues,
} from '@src/routes/Configurators/utils/constants'
import { CountryCodes } from '@src/routes/Configurators/products/DnaPlates/enum'
import useDebounce from '@src/routes/Configurators/utils/ConfiguratorDebounce'
import {
  ConfiguratorProductDetails,
  StandardConfiguratorAddToMiniCart,
} from '../../ConfiguratorSharedTypes'
import { useGetProduct } from '@src/routes/Configurators/utils/useGetProduct'
import { dropAllKeyInstances } from '@src/utils/ObjectHelpers/dropKeys'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(5, 5),
    },
    dJustifyFlexEnd: {
      justifyContent: 'flex-end',
    },
    dFlex: {
      display: 'flex',
    },
    w100: {
      width: '100%',
    },
    mgBottom3: {
      marginBottom: theme.spacing(3),
    },
    mgLeft: {
      marginLeft: '35%',
    },
    mgBottom: {
      marginBottom: theme.spacing(5),
    },
    dFlexDirectionRowReverse: {
      flexDirection: 'row-reverse',
    },
    additionalInfoText: {
      resize: 'none',
      fontFamily: 'inherit',
      '& textarea': {
        overflow: 'auto',
      },
    },
    font12: {
      fontSize: theme.typography.pxToRem(12),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(0, 0, 3),
    },
    subTotal: {
      marginBottom: theme.spacing(5),
      display: 'flex',
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightMedium,
    },
    shippingInfo: {
      fontSize: theme.typography.pxToRem(16),
      marginBottom: theme.spacing(5),
    },
    shippingNote: {
      marginBottom: theme.spacing(5),
      fontSize: theme.typography.pxToRem(12),
    },
    uploadDisable: {
      backgroundColor: theme.palette.grey[500],
    },
    isoCode: {
      fontSize: theme.typography.pxToRem(14),
      color: '#1d5293',
      fontWeight: theme.typography.fontWeightBold,
      marginTop: theme.spacing(-4),
      marginLeft: theme.spacing(-1),
    },
    fontQuote: {
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightBold,
    },
  }
})
// TODO: reimplement DLC-191 post MVP for DTAQ project
// const {
//   publicRuntimeConfig: { featureFlags },
// } = getConfig()

interface TubeDetailsForGA {
  productDetails: any
  totalQuantity: number
  price: string
  productName: string
}

interface SummaryOrderProps {
  productDetails: ConfiguratorProductDetails
  configuratorAddToMiniCart: StandardConfiguratorAddToMiniCart
  updateError: any
  itemDetails: any
}
const SummaryOrder: React.FC<SummaryOrderProps> = (props) => {
  const classes = useStyles()
  const [callDebounceCall, setCallDebounceCall] = React.useState(false)
  const [price, setPrice] = useState<string>('')
  const [totalPrice, setTotalPrice] = useState<string>('')
  const [totalItem, setTotalItem] = useState<number>(0)
  const intl = useIntl()
  const [validationErrors, setValidationErrors] = useState<string[]>([])
  let [splChar] = useState<string>('')
  const {
    productDetails,
    configuratorAddToMiniCart,
    updateError,
    itemDetails,
  } = props
  const { sapNextEnabled } = configuratorAddToMiniCart
  const { state, dispatch } = React.useContext(configContext)
  const {
    sessionData,
    productInformation,
    currentOligoIndex,
    isSessionDataRetrieved,
  } = state
  let { companionProducts } = productInformation
  companionProducts =
    companionProducts && companionProducts[0] !== '' ? companionProducts : null
  const [commentsCheckBox, setCommentsCheckBox] = React.useState(false)
  const isoCodeValue =
    sessionData[currentOligoIndex].isoCode !== null &&
    sessionData[currentOligoIndex].isoCode !== undefined &&
    sessionData[currentOligoIndex].isoCode === true
      ? true
      : false
  const [isoCode, setISOCode] = React.useState(isoCodeValue)

  const [additionalComments, setAdditionalComments] = React.useState(
    sessionData[0].additionalComments
  )
  const [isUpdateCart, setIsUpdateCart] = useState<boolean>(false)
  const [disableUpload, setDisableUpload] = React.useState(false)
  const debouncedAdditionalData = useDebounce(
    additionalComments,
    TubeProperties.SEQUENCE_API_TIME
  )
  const [addToMiniCart, { data, loading }] = useConfAddToMiniCartMutation({
    // refetchQueries: [
    //   {
    //     query: QUICK_CART,
    //     variables: { id: CartRequestAction.Mini },
    //   },
    // ],
    // awaitRefetchQueries: true,
  })
  // TODO: reimplement DLC-191 post MVP for DTAQ project
  // const { isDTAQZuCustomer, getSitePreference } = useCurrentUser()
  // const requiresPreferredDealer =
  //   featureFlags.dealerCartEnabled && isDTAQZuCustomer
  // const preferredDealerId = getSitePreference(SitePreference.PreferredDealerId)
  // const { setIsDealerModalOpen, setOnDealerSelectCallback } = useContext(
  //   DealerModalContext
  // )
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const { setGlobalSnackbarState } = useGlobalSnackbar()
  const handleAddToCart = async () => {
    // TODO: reimplement DLC-191 post MVP for DTAQ project
    // const isMissingDealer = Boolean(!preferredDealerId)
    // if (requiresPreferredDealer && isMissingDealer) {
    //   return setIsDealerModalOpen(true)
    // }

    // if (preferredDealerId)
    //   configuratorAddToMiniCart.dealerId = preferredDealerId

    return await addToMiniCart({
      variables: { input: configuratorAddToMiniCart },
      fetchPolicy: 'no-cache',
    })
  }

  const [sessionFields] = useSessionFieldsMutation()
  const [tubePriceCall] = useTubePriceCallMutation()

  const sessionDataToSession = async (obj) => {
    await sessionFields({
      variables: { input: obj, productInput: productDetails },
    })
  }
  const sequencePath = `${standardTubeRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkType.SequenceEntry}`

  const router = useRouter()
  //configuring the Configurator product data for sending it to GA
  const product = useGetProduct()

  const itemName = ProductNames[product]
  const qty = sessionData?.length
  const configProductDetails: TubeDetailsForGA = getConfiguratorGAdata(
    itemDetails,
    sessionData,
    itemName,
    qty,
    productDetails.locale,
    productInformation.currencyFormat
  )

  //function to extract the special characters from the string passed
  const checkSpecialChar = (args): string => {
    splChar = ''
    args.value.split('').forEach((c) => {
      if (c.match(/^[~!@$^|{}?<>—’'"&%]*$/) && !splChar.includes(c)) {
        if (splChar === '') {
          splChar = c
        } else {
          splChar = splChar + ', ' + c
        }
      }
    })
    return splChar
  }

  const setLength = () => {
    let lengthOfComment = 0
    let maxLength = 0
    sessionData.forEach((data) => {
      if (data.comments && data.comments.length > lengthOfComment) {
        lengthOfComment = data.comments.length
      }
    })
    if (sapNextEnabled) {
      maxLength = 999 - lengthOfComment
    } else {
      maxLength = 90 - lengthOfComment
    }
    return maxLength
  }

  const calculatePrice = () => {
    let totalPrice = 0
    let isPriceValid = true

    sessionData.forEach((data) => {
      if (
        data.price &&
        data.price !== TubeProperties.Quote &&
        data.price !== '--'
      ) {
        totalPrice = totalPrice + parseFloat(data.price)
      } else if (data.price === TubeProperties.Quote) {
        setPrice(intl.formatMessage(messages._PC_QUOTE_ITEM))
        isPriceValid = false
      } else {
        setPrice('--')
        isPriceValid = false
      }
    })
    if (isPriceValid) {
      const formattedPrice = priceFormatter(
        totalPrice,
        productInformation.currencyFormat,
        productInformation.thousandSeparator,
        productInformation.thousandSpacing,
        productInformation.decimalSeparator,
        productInformation.prefixCurrecny,
        sessionData[0].currencySymbol
      )

      const priceData = formattedPrice

      setPrice(priceData)
    }
    if (
      sessionData[0].additionalComments !== null &&
      sessionData[0].additionalComments !== undefined &&
      sessionData[0].additionalComments.length > 0
    ) {
      setCommentsCheckBox(true)
    }
  }
  // TODO: reimplement DLC-191 post MVP for DTAQ project
  // useEffect(() => {
  //   const isMissingDealer = Boolean(!preferredDealerId)
  //   if (requiresPreferredDealer && isMissingDealer) {
  //     setOnDealerSelectCallback(() => handleAddToCart)
  //   }
  // }, [preferredDealerId])

  React.useEffect(() => {
    if (data?.confAddToMiniCart?.result !== TubeProperties.Success) {
      calculatePrice()
    }
    const cartItems = sessionData.filter((tube) => {
      return tube?.cartId?.length && tube?.itemId?.length
    })
    if (!isUpdateCart)
      // added for STRAT-18888 2nd Observation
      cartItems.length ? setIsUpdateCart(true) : setIsUpdateCart(false)

    // TODO: need a test before we refactor these dependencies
  }, [[state.currentOligoIndex], data])

  React.useEffect(
    () => {
      if (callDebounceCall) {
        setCallDebounceCall(false)
        sessionDataToSession(sessionData)
      }
    },
    // TODO: need a test before we refactor these dependencies

    [debouncedAdditionalData]
  )

  const handleComments = (value) => {
    setCallDebounceCall(true)
    setAdditionalComments(value)
    sessionData.forEach((tube) => {
      tube.additionalComments = value
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
  }

  const clearSessionData = () => {
    sessionDataToSession([])

    dispatch({
      type: 'UPDATE_OLIGO_INDEX',
      data: 0,
    })
    dispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: 0,
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [EMPTY_SESSION],
    })

    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: {
        ...state.errorData,
        name: '',
        sequence: '',
        scale: '',
        purification: '',
        fiveMod: '',
        threeMod: '',
        researcher: '',
        format: '',
        concentration: '',
        tubes: '1',
        countryCode: '',
        fullSOligoBackbone: false,
        isOverridden: false,
        comments: '',
        cterminalMod: '',
        nterminalMod: '',
        otherValue: '',
        isLabelledAminoAcid: true,
        quantitation: '',
        purityLevel: '',
        amount: '',
        additionalServices: [],
        flag: 0,
      },
    })
  }

  const priceCall = async (sessionData) => {
    sessionData.forEach((item) => {
      item.listError.forEach((data) => {
        // Drop __typename from the data object and then bind that return to the data on the loop.
        const dataRecast = dropAllKeyInstances(data, ['__typename'])
        data = dataRecast
      })
    })
    const response: any = await tubePriceCall({
      variables: { input: sessionData, productInput: productDetails },
    })
    if (response) {
      let isValid = true
      response.data.tubePriceCall.result.forEach((item, index) => {
        item.listErrors.forEach((item) => {
          delete item.__typename
        })
        if (item.listErrors.length !== 0) {
          router.push(sequencePath)
          isValid = false
        } else {
          state.sessionData[index].price = item.price
          state.sessionData[index].priceHeaderError = item.priceHeaderError
          state.sessionData[index].currencySymbol = item.currencySymbol
          state.sessionData[index].currency = item.currency
        }
      })
      if (isValid) {
        dispatch({ type: 'IS_CONFIRM_ORDER', data: true })
        dispatch({ type: 'SET_STEP_NO', data: 1 })
      }
    }
  }
  const handleCommentsOnChange = (value) => {
    value = convertToASCII(value)
    handleComments(value)
    const val = checkSpecialChar({ value })
    const surrogateCharacters = validateSurrogateCharacters(value)
    let invalidcharExist = false
    const validator = yup
      .string()
      .max(
        setLength(),
        intl.formatMessage(messages.CONF_ADD_INFO_MAX_VALIDATION_MSG) +
          setLength()
      )
      .matches(
        /^[^~!@$^|{}?<>—’'"&%]*$/,
        `${intl.formatMessage(messages.CONF_SPL_CHAR_VALIDATION_MSG)} ${val}`
      )
    const errors: string[] = []
    try {
      if (surrogateCharacters.length !== 0) {
        setValidationErrors([
          `${intl.formatMessage(
            messages.CONF_SPL_CHAR_VALIDATION_MSG
          )} ${surrogateCharacters}`,
        ])
        updateError(true)
        dispatch({ type: 'IS_SIDE_NAV_DISABLE', data: true })
        setDisableUpload(true)
      } else {
        setValidationErrors([])
        updateError(false)
        dispatch({ type: 'IS_SIDE_NAV_DISABLE', data: false })
        dispatch({ type: 'SET_PAGE_ERROR', data: '' })
        setDisableUpload(false)
      }
      validator.validateSync(value, {
        abortEarly: false,
      })
    } catch (error: any) {
      for (const err of error.errors) {
        if (
          err.includes(
            intl.formatMessage(messages.CONF_SPL_CHAR_VALIDATION_MSG)
          )
        ) {
          surrogateCharacters.length !== 0
            ? errors.push(err + ', ' + surrogateCharacters)
            : errors.push(err)
          invalidcharExist = true
        } else {
          errors.push(err)
        }
      }
      if (!invalidcharExist && surrogateCharacters.length !== 0) {
        errors.push(
          `${intl.formatMessage(
            messages.CONF_SPL_CHAR_VALIDATION_MSG
          )} ${surrogateCharacters}`
        )
      }
      setValidationErrors(errors)
      updateError(true)
      dispatch({ type: 'IS_SIDE_NAV_DISABLE', data: true })
      setDisableUpload(true)
    }
    return undefined
  }

  React.useEffect(() => {
    if (isSessionDataRetrieved) {
      if (state.onContinueButtonPriceCall !== true) {
        if (state.sessionData) {
          priceCall(state.sessionData)
        }
      } else {
        dispatch({
          type: 'ON_CONTINUE_BUTTON_PRICECALL',
          data: false,
        })
      }
    }
  }, [isSessionDataRetrieved])

  React.useEffect(() => {
    if (productDetails.productType === TubeProduct.iscaledna) {
      dispatch({ type: 'IS_BULK_REVIEW', data: false })
      dispatch({ type: 'IS_SIDE_NAV_DISABLE', data: false })
    }
    dispatch({
      type: 'CALL_RULE_VALIDATION',
      data: false,
    })
    if (
      sessionData[0].additionalComments !== null &&
      sessionData[0].additionalComments !== undefined &&
      sessionData[0].additionalComments.length > 0
    ) {
      handleCommentsOnChange(sessionData[0].additionalComments)
    }
    // TODO: need a test before we refactor these dependencies
  }, [])

  React.useEffect(() => {
    if (data) {
      const errorMessage = ConfiguratorValues.AddToCartFail
      if (data?.confAddToMiniCart?.serverError) {
        updateError(ConfiguratorValues.AddToCartFail)
        window.scrollTo(0, 0)
        //GAtracking event on button click of addToCart
        handleGAAddToCartErrorsForConfigurator(
          configProductDetails,
          errorMessage
        )
      } else {
        if (data?.confAddToMiniCart?.result === TubeProperties.Success) {
          //GAtracking event on button click of addToCart
          handleGAAddToCartForConfigurator(configProductDetails)
          setTotalPrice(price)
          setTotalItem(sessionData.length)
          setDialogOpen(true)
        } else if (
          data?.confAddToMiniCart?.result === ErrorMessage.SessionDataEmpty
        ) {
          clearSessionData()
          router.push(sequencePath)
        } else if (
          data?.confAddToMiniCart?.result === ErrorMessage.AccessTokenExpire
        ) {
          router.push(loginRoute.index())
          setGlobalSnackbarState({
            open: true,
            message: (
              <FormattedMessage
                {...messages.USER_NOT_AUTHORIZED_OR_TOKEN_EXPIRED}
              />
            ),
            variant: SnackbarType.Error,
          })
        } else {
          handleGAAddToCartErrorsForConfigurator(
            configProductDetails,
            ConfiguratorValues.AddToCartFail
          )
          updateError(ConfiguratorValues.AddToCartFail)
        }
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [data])

  const handleISOCode = (event) => {
    const { checked } = event.target

    if (checked !== null || checked !== undefined) {
      setISOCode(checked)
      sessionData.forEach((data) => {
        data.isoCode = checked
      })
    }
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    sessionDataToSession(sessionData)
  }
  const handleAknowledgeCheckBox = (value) => {
    setCommentsCheckBox(value)
    if (!value) {
      handleComments('')
      setDisableUpload(false)
      updateError(false)
      setValidationErrors([])
      dispatch({ type: 'IS_SIDE_NAV_DISABLE', data: false })
      dispatch({ type: 'SET_PAGE_ERROR', data: '' })
    }
  }

  return (
    <>
      <DownloadSummary productDetails={productDetails} />
      <div
        className={clsx(
          classes.contentWrapper,
          classes.dFlex,
          classes.dFlexDirectionRowReverse
        )}
      >
        <Box>
          <div className={classes.w100}>
            <div className={clsx(classes.mgBottom3, classes.font12)}>
              <h2 className={classes.subHead}>
                <FormattedMessage {...messages.CART_SUMMARY} />
              </h2>
              <Divider />
            </div>

            <Grid container className={classes.subTotal}>
              <Grid item xs={4} sm={4}>
                <FormattedMessage
                  id="CART_SUBTOTAL"
                  defaultMessage="Subtotal"
                />
                :
              </Grid>
              <Grid
                item
                xs={8}
                sm={8}
                className={clsx(classes.dFlex, classes.dJustifyFlexEnd)}
              >
                {price}
              </Grid>
            </Grid>
            {productDetails.isCSRSupervisor &&
            (productDetails.productType === TubeProduct.Standard ||
              productDetails.productType === TubeProduct.Probe) ? (
              <div className={classes.isoCode}>
                <Checkbox
                  checked={isoCode}
                  onClick={handleISOCode}
                  value={isoCode}
                  color="primary"
                />
                <span>
                  <FormattedMessage {...messages.CONF_ISO_CODE} />
                </span>
              </div>
            ) : (
              ''
            )}

            <div className={classes.shippingInfo}>
              <span>
                <strong>
                  <FormattedMessage {...messages.SHIPPING} />:{' '}
                </strong>
                <span>
                  <FormattedMessage {...messages.CONF_AMBIENT_ROOM_TEMP} />
                </span>
              </span>
            </div>
            <div className={classes.shippingNote}>
              {price === intl.formatMessage(messages._PC_QUOTE_ITEM) ? (
                <span className={classes.fontQuote}>
                  <FormattedMessage {...messages.CART_QUOTATION_TEXT} />{' '}
                </span>
              ) : (
                <>
                  <strong>
                    <FormattedMessage
                      id="CART_ITEM_NOTE"
                      defaultMessage="Note"
                    />
                    :{' '}
                  </strong>
                  <FormattedMessage {...messages.CONF_PRICE_SUB_TOTAL} />
                </>
              )}
              <ul>
                <li>
                  <FormattedMessage {...messages.CONF_APPLICATIONFREIGHT_TAX} />
                </li>
                <li>
                  <FormattedMessage {...messages.CONF_PROMOTIONAL_CODES} />
                </li>
              </ul>
            </div>
            {CountryCodes.JP === productDetails.countryCode ? (
              ''
            ) : (
              <>
                <div>
                  <h3>
                    <FormattedMessage
                      {...messages.CONF_ADDITIONAL_SHIPPING_INFO}
                    />
                  </h3>
                </div>
                <div className={classes.font12}>
                  <Checkbox
                    checked={commentsCheckBox}
                    value={commentsCheckBox}
                    color="primary"
                    onChange={() => {
                      handleAknowledgeCheckBox(!commentsCheckBox)
                    }}
                  />
                  <FormattedMessage {...messages.CONF_ACKNOWLEDGE_DNA_PLATES} />
                </div>

                <Formik
                  initialValues={{ addInfo: '' }}
                  validateOnChange={false}
                  onSubmit={(values, actions) => {
                    setTimeout(() => {
                      actions.setSubmitting(false)
                    }, 1000)
                  }}
                >
                  {
                    <Form>
                      <div className={clsx(classes.mgBottom, classes.font12)}>
                        <Field
                          name="addInfo"
                          component={LiquidInputAdapter}
                          placeholder={intl.formatMessage(
                            messages.CONF_ENTER_ADDITIONAL_INFO
                          )}
                          multiline
                          spellCheck={'false'}
                          rows={6}
                          rowsMax={6}
                          filled
                          className={clsx(
                            classes.w100,
                            classes.additionalInfoText
                          )}
                          disabled={!commentsCheckBox}
                          value={additionalComments}
                          onChange={(e) => {
                            handleCommentsOnChange(e.target.value)
                          }}
                          inputProps={{
                            'data-scrub': 'true',
                          }}
                        />
                        <ValidationErrors errors={validationErrors} />
                      </div>
                    </Form>
                  }
                </Formik>
              </>
            )}

            <div className={clsx(classes.w100, classes.font12)}>
              <Button
                variant="contained"
                color="primary"
                className={clsx(
                  classes.w100,
                  disableUpload && classes.uploadDisable
                )}
                disabled={loading || disableUpload}
                onClick={handleAddToCart}
                id={
                  isUpdateCart
                    ? 'summary-order-update-cart'
                    : 'summary-order-add-to-cart'
                }
              >
                {isUpdateCart ? (
                  <FormattedMessage {...messages.UPDATE_CART} />
                ) : (
                  <FormattedMessage
                    id="ADD_TO_CART"
                    defaultMessage="Add to Cart"
                  />
                )}
              </Button>
            </div>
            <AddToCartItems
              dialogOpen={dialogOpen}
              setDialogOpen={setDialogOpen}
              price={totalPrice}
              totalItem={totalItem}
              companionProducts={companionProducts}
              productType={productDetails.productType}
            />
          </div>
        </Box>
      </div>
      {loading && <CircleLoader />}
    </>
  )
}
export default SummaryOrder
